import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import strings from "../../config/localization";

interface Props {
  open: boolean;
  closeHandler: () => void;
  title?: string;
  message?: string;
  closeStr?: string;
}

export default function ErrorMsgDialog({
  open,
  closeHandler,
  title = strings.defaultDeleteFailedTitle,
  message = strings.defaultDeleteFailedMsg,
  closeStr = strings.close,
}: Props) {
  return (
    <Dialog open={open}>
      <DialogTitle id="alert-dialog-title"> {title} </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {" "}
          {message}{" "}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeHandler}> {closeStr} </Button>
      </DialogActions>
    </Dialog>
  );
}
